import api from 'api';

export const createConversion = api('POST /api/integrations/conversions');

export const loadConversion = api('GET /api/integrations/conversions/:id');

export const editConversion = api('PUT /api/integrations/conversions/:id/edit');

export const loadConversionDetails = api(
  'GET /api/integrations/conversions/:id/details'
);

export const loadConversionInfoSchema = api(
  'GET /api/integrations/conversions/schema/:providerTypeId'
);
